import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

// Legacy free-text products.supplier -> Supplier Directory. Exact/normalized matches link in one tap; uncertain ones require an explicit choice.
export function SupplierLegacyLink({ onDone }) {
  const [rows, setRows] = useState(null); const [sups, setSups] = useState([]); const [choice, setChoice] = useState({});
  const load = () => { api.get("/suppliers/legacy-names").then((r) => setRows(r.data)); api.get("/suppliers", { params: { status: "active" } }).then((r) => setSups(r.data)); };
  useEffect(load, []);
  const act = async (row, action, supplier_id) => {
    try {
      const { data } = await api.post("/suppliers/legacy-names/link", { legacy_name: row.legacy_name, action, supplier_id });
      if (action !== "skip") toast.success(`${data.linked} product(s) linked`);
      if (action === "skip") setRows((r) => r.filter((x) => x.legacy_name !== row.legacy_name)); else load();
      onDone && onDone();
    } catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (rows === null) return <p className="text-sm text-muted-foreground">Scanning product supplier names…</p>;
  if (!rows.length) return <p className="text-sm text-muted-foreground" data-testid="legacy-empty">All typed supplier names are linked. Nothing to do.</p>;
  return (
    <div className="space-y-2 max-h-[65vh] overflow-y-auto pr-1" data-testid="legacy-list">
      <p className="text-xs text-muted-foreground">Products still carry their typed supplier name. Linking adds a supplier–product relationship; nothing is merged or renamed.</p>
      {rows.map((r) => {
        const key = r.legacy_name; const sel = choice[key] ?? (r.suggestion?.id || "");
        const sure = r.confidence === "exact" || r.confidence === "normalized";
        return (
          <div key={key} className="rounded-lg border border-border p-3 space-y-2 text-sm" data-testid={`legacy-row-${key}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div><span className="font-medium">"{r.legacy_name}"</span> <span className="text-xs text-muted-foreground">· {r.product_count} product{r.product_count === 1 ? "" : "s"}</span></div>
              <Badge variant="outline" className={sure ? "text-emerald-600" : r.confidence === "uncertain" ? "text-amber-600" : "text-muted-foreground"} data-testid={`legacy-confidence-${key}`}>{sure ? `${r.confidence} match: ${r.suggestion.name}` : r.confidence === "uncertain" ? `uncertain — confirm: ${r.suggestion.name}?` : "no match"}</Badge>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <select className="h-9 rounded-md border border-border bg-background px-2 text-sm" value={sel} onChange={(e) => setChoice({ ...choice, [key]: e.target.value })} data-testid={`legacy-select-${key}`}>
                <option value="">— choose existing supplier —</option>
                {sups.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
              <Button size="sm" disabled={!sel} className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={() => act(r, "link", sel)} data-testid={`legacy-link-${key}`}>{sure ? "Link" : "Confirm & link"}</Button>
              <Button size="sm" variant="outline" onClick={() => act(r, "create")} data-testid={`legacy-create-${key}`}>Create new supplier</Button>
              <Button size="sm" variant="ghost" onClick={() => act(r, "skip")} data-testid={`legacy-skip-${key}`}>Skip</Button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
